import moment from "moment";
import {WizClassifySelect} from "../../index";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "标题",
      name: "name",
      dataIndex: "name",
      searchItem: {},
      tableItem: {
        width: 200
      }
    },
    // {
    //   title: "分类",
    //   name: "categoryName",
    //   dataIndex: "categoryName",
    //   tableItem: {
    //     width: 200
    //   }
    // },
    // {
    //   title: "分类",
    //   name: "categoryId",
    //   dataIndex: "categoryId",
    //   searchItem: {
    //     type: 'treeselect',
    //     allowClear:true,
    //     dict: {
    //       wizReplaceData: "treeData",
    //       defalutType: []
    //     },
    //   }
    // },
    // {
    //   title: "分类",
    //   name: "categoryId",
    //   dataIndex: "categoryId",
    //   searchItem: {
    //     type: 'diy',
    //     diy: WizClassifySelect,
    //     returnKey: true,
    //     wizTreeSelectListProps: {
    //       itemProps: {
    //         icon: 'unordered-list',
    //         title: '分类',
    //         tips: '请勾选所属分类'
    //       },
    //       treeProps: { checkStrictly: true },
    //       checkable: false
    //     },
    //     apiProps: { type: 11 ,state:1},
    //     selectProps: {
    //       placeholder: '请选择分类'
    //     }
    //   }
    // },
    {
      title: "开始时间",
      name: "startDate",
      dataIndex: "startDate",
      width: 150,
      tableItem: {
        width: 200
      }
    },
    {
      title: "结束时间",
      name: "endDate",
      dataIndex: "endDate",
      width: 150,
      tableItem: {
        width: 200
      }
    },
    {
      title: "是否需要批阅",
      name: "reviewType",
      dataIndex: "reviewType",
      tableItem: {
        width: 230
      },
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: 0, codeName: "人工" },
        { code: 1, codeName: "智能" },
        { code: 2, codeName: "无需批阅" },
      ],
    },
    {
      title: "是否公开展示",
      name: "open",
      dataIndex: "open",
      tableItem: {
        width: 230
      },
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: 0, codeName: "否" },
        { code: 1, codeName: "是" },
      ],
    },
    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      tableItem: {
        width: 100
      },
      dict: [
        { code: 0, codeName: "草稿" },
        { code: 1, codeName: "已发布" },
        { code: 2, codeName: "已取消" },
        { code: 3, codeName: "已结束" }
      ],
    },
    {
      title: "作业时间",
      name: "searchDate",
      dataIndex: "searchDate",
      searchItem: {
        type: 'date~',
        showTime: false,
        format: 'YYYY-MM-DD'
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'homework/listByPage',
    ...api,
  }
}

const homework = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowkey: 'id',
    rowName: 'name',
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api),
    searchProps: {
      dataFormat: (v) => {
        let value = Object.assign([], v)
        if (value['categoryId'] && value['categoryId'].length > 0) {
          value['categoryId'] = value['categoryId'][0]
        }

        if (value['searchDate'] && value['searchDate'].length === 2) {
          value['startDate'] = moment(value['searchDate'][0]).format("YYYY-MM-DD HH:mm:00")
          value['endDate'] = moment(value['searchDate'][1]).format("YYYY-MM-DD HH:mm:59")
        }
        delete value['searchDate']

        return value
      }
    },
  }
}

export default homework
